import { Button, Modal, Tag, Tooltip } from "antd";
import { useCallback, useEffect, useState } from "react";
import apiCalls from "src/api/apiCalls";
import Loader from "../shared/loader.component";
import ErrorMessage from "../shared/messages/errorMessage";

const UserDetailsView = ({isModalOpen,closeModel,selectedUserId }) => {
  const [userData, setUserData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [errorMsg,setErrorMsg]=useState(null)
  useEffect(() => {
    if (selectedUserId) {
      getUserDetails(selectedUserId);
    }
  }, [selectedUserId]);

  const getUserDetails = useCallback(async () => {
    try {
      setLoader(true);
      const res = await apiCalls.getUserData(selectedUserId);
      if (res.ok) {
        setUserData(res?.data);
      } else {
        setErrorMsg(res?.error?.message);
      }
    } catch (error) {
      apiCalls.isErrorDispaly(error);
    } finally {
      setLoader(false);
    }
  }, [selectedUserId]);

  const closeErrorHandler=useCallback(()=>{
    setErrorMsg(null)
   },[])

const closeModelHandler=useCallback(()=>{
  closeModel(false)
},[])

  return (
    <div>
      <Modal
        title="User Details"
        open={isModalOpen}
        onCancel={closeModelHandler}
        closeIcon={
          <Tooltip title={"close"}>
             <span className='icon close'></span>
          </Tooltip>}

        footer={null}
        destroyOnClose
      >
        {errorMsg && <ErrorMessage msg={errorMsg} onClose={closeErrorHandler} />}
        {loader ? (<Loader />) : (<>
            <div className="grid grid-cols-2 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 gap-6">
              <div>
                <p className="summary-label">User Name</p>
                <p className="summary-value word-breall">{userData?.userName || ""}</p>
              </div>
              <div>
                <p className="summary-label">First Name</p>
                <p className="summary-value word-breall">{userData?.name || ""}</p>
              </div>
              <div>
                <p className="summary-label">Last Name</p>
                <p className="summary-value word-breall">{userData?.surname || ""}</p>
              </div>
              <div>
                <p className="summary-label">Phone No</p>
                <p className="summary-value word-breall">{userData?.phoneNumber || ""}</p>
              </div>
              <div>
                <p className="summary-label">Email</p>
                <p className="summary-value !w-40 ">{userData?.email || ""}</p>
              </div>
              <div>
                <p className="summary-label">Status</p>
                <span
                  className={`font-medium text-base ${
                    userData?.isActive ? "!text-statusGreen" : "!text-statusred"
                  }`}
                >
                  {userData?.isActive ? "Active" : "Inactive"}
                </span>
              </div>
              <div>
                <p className="summary-label mb-2">Roles</p>
                {userData?.roleNames?.map((role) => (
                  <Tag
                    className="!border-none mt-1 !text-lightDark !bg-tabactive rounded-5 !px-3 !py-1.5 text-center"
                    key={role}
                  >
                   <span className="md:!w-auto w-full whitespace-pre-line break-words !bg-tabactive"> {role}</span>
                  </Tag>
                ))}
              </div>
             
            </div>
             <div className='mt-6 text-right mb-6'><Button className='primary-btn' onClick={closeModel}>Close</Button></div>
             </>
        )}
      </Modal>
    </div>
  );
};

export default UserDetailsView;
